import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import PerfectScrollbar from 'react-perfect-scrollbar'
import PropTypes from 'prop-types'
//Material-UI
import { makeStyles } from '@material-ui/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
//Icons
//import AddIcon from '@material-ui/icons/Add'
//import EditIcon from '@material-ui/icons/Edit'

//DS
import Detalle from './Detalle'
import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    //padding: 0
  },
  inner: {
    // minWidth: 700
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}))

const statusColors = {
  delivered: 'success',
  pending: 'info',
  refunded: 'danger'
}

var sortBy = (function () {
  var toString = Object.prototype.toString,
      // default parser function
      parse = function (x) { return x; },
      // gets the item to be sorted
      getItem = function (x) {
        var isObject = x != null && typeof x === "object";
        var isProp = isObject && this.prop in x;
        return this.parser(isProp ? x[this.prop] : x);
      };

  /**
   * Sorts an array of elements.
   *
   * @param  {Array} array: the collection to sort
   * @param  {Object} cfg: the configuration options
   * @property {String}   cfg.prop: property name (if it is an Array of objects)
   * @property {Boolean}  cfg.desc: determines whether the sort is descending
   * @property {Function} cfg.parser: function to parse the items to expected type
   * @return {Array}
   */
  return function sortby (array, cfg) {
    if (!(array instanceof Array && array.length)) return [];
    if (toString.call(cfg) !== "[object Object]") cfg = {};
    if (typeof cfg.parser !== "function") cfg.parser = parse;
    cfg.desc = !!cfg.desc ? -1 : 1;
    return array.sort(function (a, b) {
      a = getItem.call(cfg, a);
      b = getItem.call(cfg, b);
      return cfg.desc * (a < b ? -1 : +(a > b));
    });
    
  };

}());
const TicketDetalle = props => {
  const [abrir, setAbrir] = useState(false);

  const { className, ...rest } = props;
  const classes = useStyles();
  const [detalleAtencion, setDetalleAtencion] = useState(sortBy(props.data, { prop: "fecha", desc: true }));

  function handleResponder() {    
    setAbrir(true);    
  }
  useEffect(() => {
    if(abrir)
    {
      props.setResponder(true);
      setAbrir(false);
    }
  }, [abrir])
  

  return (
    <>
      <Card>
        <CardHeader          
          action={
            <>
             {/* <IconButton aria-label="add" className={classes.margin} onClick={handleAgregar}>
                <AddIcon fontSize="small" />
              </IconButton>
              <IconButton aria-label="edit" className={classes.margin} onClick={handleEditar}>
                <EditIcon fontSize="small" />
          </IconButton>*/}              
              {(props.estado !== 3 /*by Alex*/) && <Button color="primary" onClick={handleResponder} >Responder</Button>}
            </>
          }
        />
      </Card>
      <Divider />

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>      
            {detalleAtencion.map(detalle => (
              <Detalle detalle={detalle} key={detalle.codigo} />                           
            ))}
          </div>
        </PerfectScrollbar>        
      </CardContent>
    </>
  )
}

TicketDetalle.propTypes = {
  className: PropTypes.string
}

export default TicketDetalle;
